import {utilModule} from '../module.js';

utilModule.directive('nsIbanValidator', ['nsUtil', function(nsUtil) {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {

            console.log("In nsIbanValidator...");
            ele.on('blur', function () {
                scope.$apply(function () {
                    let isValid = nsUtil.ibanValidator(ele.val());
                    console.log("Calling onbur for nsIbanValidator=" + isValid);
                    ctrl.$setValidity('nsIbanValidator', isValid);
                });
            });
        }
    };
}]);
